import React, {useState} from 'react';
import { useSelector } from 'react-redux';
import PriceOverrideHestory from './priceOverrideHistory/PriceOverrideHistory';
import PriceOverrideDetails from './priceOverrideDetails/PriceOverrideDetails';
import PriceOverrideSummary from './priceOverrideSummary/PriceOverrideSummary';
import { OrderDetailTitle } from 'src/pages/orders/components/orderDetails/OrderDetails.styled';
import {
    getDisplayDate
} from 'src/utils/dateUtils';
import { sizes } from 'src/styles/Media.styled';
import {
    OrderDetailFooterContainer,
    InvoiceCreatedDetail,
    WrapperContainer,
} from './index.styled';
import { convertTime24To12} from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const PriceOverride = ({ handleSetItemClick, ordersList }) => {

    const [modifyDate, setModifyDate] = useState('');
    const [modifyTime, setModifyTime] = useState('');
    const winWidth = window.innerWidth;
    const { t } = useTranslation();

    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );

    const { isLanguageChanged } = useSelector((state) => ({
        isLanguageChanged: state.loginReducer.isLanguageChanged,
    }));

    const { orderBasicDetails, lastModifiedBy, lastModifiedDate } = useSelector(
        (state) => ({
            orderBasicDetails: state.orderSummaryReducer.orderBasicDetails,
            lastModifiedBy:
                state.orderSummaryReducer.orderBasicDetails?.orderSummaryDetail
                    ?.lastModifiedBy,
            lastModifiedDate:
                state.orderSummaryReducer.orderBasicDetails?.orderSummaryDetail
                    ?.lastModifiedDate,
        })
    );

    useEffectWithErrorLogging(() => {
        if (lastModifiedDate && lastModifiedDate !== '') {
            setModifyDate(
                getDisplayDate(new Date(lastModifiedDate))
            );
            setModifyTime(convertTime24To12(new Date(lastModifiedDate)));
        }
    }, [lastModifiedDate]);
    return (
        <>
            <OrderDetailTitle mbMargin={isCondensedView && '10px 0px 20px 14px'}>{t('consignmentReturn.billing.priceOverride')}</OrderDetailTitle>
            <PriceOverrideSummary />
            <PriceOverrideDetails
                handleSetItemClick={handleSetItemClick}
                ordersList={ordersList}
            />
            <PriceOverrideHestory />
            {( winWidth <= sizes.mobileDevice ) && orderBasicDetails?.currentOrderType === 'KE'? (
                <OrderDetailFooterContainer>
                    {lastModifiedBy || modifyDate || modifyTime ? (
                        <>
                            <InvoiceCreatedDetail margin={'0 3px 0 0'}>
                                {isLanguageChanged && lastModifiedBy?'':t('orders.orderSummaryTabs.lastmodify')}
                            </InvoiceCreatedDetail>
                            {lastModifiedBy ? (
                                <>
                                    <InvoiceCreatedDetail margin={'0 3px 0 0'}>
                                        {isLanguageChanged ?t('orders.orderSummaryTabs.lastmodify'):t('orders.orderDetails.billingSummary.by')}
                                    </InvoiceCreatedDetail>
                                    <InvoiceCreatedDetail
                                        margin={'0 2px 0 0'}
                                        isCreatedDateBy
                                    >
                                        {lastModifiedBy}
                                    </InvoiceCreatedDetail>
                                </>
                            ) : null}
                            <WrapperContainer>
                                {modifyDate ? (
                                    <InvoiceCreatedDetail
                                        margin={'0 2px 0 -1px'}
                                    >
                                        {modifyDate}
                                    </InvoiceCreatedDetail>
                                ) : null}
                                {modifyTime ? (
                                    <InvoiceCreatedDetail>
                                        {modifyTime}{' '}
                                            {'IST'}
                                    </InvoiceCreatedDetail>
                                ) : null}
                            </WrapperContainer>
                        </>
                    ) : null}
                </OrderDetailFooterContainer>
            ) : null}
        </>
    );
};

export default PriceOverride;
